

var msgModel = [];
msgModel['ERR0000'] = 'Unidentified Error. Please contact to administrator';
msgModel['MSG0000'] = 'Bill Saved';
msgModel['MSG0001'] = 'Invalid username or password.';
msgModel['MSG0002'] = 'Session has been expired. Please login again.';
msgModel['MSG0003'] = 'User is inactive.';
msgModel['MSG0004'] = 'User is blocked by Admin or Head office.';
msgModel['MSG0005'] = 'Please check password policy.';
msgModel['MSG0006'] = 'Please fill mandatory feilds.';
msgModel['MSG0007'] = 'Date of birth sould be less than today.';
msgModel['MSG0008'] = 'Payment does not tally. Please check.';
msgModel['MSG0009'] = 'New password and confirm password does not match.';
msgModel['MSG0010'] = "Date should be within financial year.";
msgModel['WRN0000'] = "Do you really want to discard the changes.";
msgModel['MSG0011'] = "Entry can't be made for Future date.";
msgModel['GSTWRN000.'] = "Invalid GSTIN.";
msgModel['MSG0012'] = "Unlock not given.";
msgModel['MSG0013'] = "Please press CTRL F5.";






export const getMessage = (key) => {
    return msgModel[key];
}

export const HoCode = "1001";

export const Billprint = "1";

export const apiBasePath = "";
/*export const apiBasePath = "http://localhost:1001";*/ // same
//export const apiBasePath = "http://localhost:2001"; // cross domain

export const apiPicklist = apiBasePath + "/api/picklist_a.php";
export const apiLogin = apiBasePath + "/api/login_a.php";
export const apiUser = apiBasePath + "/api/user_a.php";
export const apiCountry = apiBasePath + '/api/country_a.php';
export const apiState = apiBasePath + '/api/state_a.php';
export const apiCity = apiBasePath + '/api/city_a.php';
export const apiIsd = apiBasePath + '/api/isd_a.php';
export const apiIssuer = apiBasePath + '/api/issuer_a.php';
export const apiEntity = apiBasePath + '/api/entity_a.php';
export const apiRightGroup = apiBasePath + '/api/right_group_a.php';
export const apiRight = apiBasePath + '/api/right_a.php';
export const apiPurpose = apiBasePath + '/api/purpose_a.php';
export const apiUploadFile = apiBasePath + '/api/upload_a.php';
export const apiIdtype = apiBasePath + '/api/idtype_a.php';
export const apiDealer = apiBasePath + '/api/dealer_a.php';
export const apiVoucher = apiBasePath + '/api/voucher_a.php';
export const apiLedger = apiBasePath + '/api/ledger_a.php';
export const apiLedgerView = apiBasePath + '/api/ledger_view_a.php';
export const apiRegion = apiBasePath + '/api/region_a.php';

export const apiCountryClass = apiBasePath + '/api/country_class_a.php';
export const apiDivision = apiBasePath + '/api/division_a.php';
export const apiRisk = apiBasePath + '/api/risk_a.php';
export const apiBusinessNature = apiBasePath + '/api/business_nature_a.php';
export const apiLegalEntity = apiBasePath + '/api/legal_entity_a.php';
export const apiDistrict = apiBasePath + '/api/district_a.php';
export const apiCostCenter = apiBasePath + '/api/cost_center_a.php';
export const apiGstClassification = apiBasePath + '/api/gst_classification_a.php';
export const apiMsme = apiBasePath + '/api/msme_a.php';
export const apiDesignation = apiBasePath + '/api/designation_a.php';
export const apiExecutive = apiBasePath + '/api/executive_a.php';
export const apiExpense = apiBasePath + '/api/local_expence_a.php';
export const apiSubExecutive = apiBasePath + '/api/sub_executive_a.php';
export const apiVoucherType = apiBasePath + '/api/voucher_type_a.php';
export const apiIndividualProfile = apiBasePath + '/api/individual_profile_a.php';
export const apiGrpDoc = apiBasePath + '/api/doc_link_a.php';
export const apiReport = apiBasePath + '/api/report_a.php';
export const apiDocument = apiBasePath + '/api/document_a.php';
export const apiActivityLog = apiBasePath + '/api/activitylog_a.php';
export const apiFinYear = apiBasePath + '/api/finyear_a.php';
export const apiTranPP = apiBasePath + '/api/tran_pp_a.php';
export const apiTranOpnTrial = apiBasePath + '/api/tran_opn_trial_a.php';
export const apiResidentialStatus = apiBasePath + '/api/residential_status_a.php';
export const apiTranOpnCmr = apiBasePath + '/api/tran_opn_cmr_a.php';
export const apiTranCurrencyStocks = apiBasePath + '/api/tran_currency_stock_a.php';
export const apiTranOpnVtc = apiBasePath + '/api/tran_opn_vtc_a.php';
export const apiOpnBankStmt = apiBasePath + '/api/opn_bank_statement_a.php';
export const apiTranOpnTc = apiBasePath + '/api/tran_opn_tc_a.php';
export const apiTranOpnEtc = apiBasePath + '/api/tran_opn_etc_a.php';
export const apiVtmEncash = apiBasePath + '/api/vtm_encashment_a.php';
export const apiTranOpnEvtm = apiBasePath + '/api/tran_opn_evtm_a.php';
export const apiTranOpnTcSt = apiBasePath + '/api/tran_opn_tc_st_a.php';
export const apiTranOpnVtmSt = apiBasePath + '/api/tran_opn_vtm_st_a.php';
export const apiBankChequeBookIn = apiBasePath + '/api/bank_cheque_book_in_a.php';
export const apiBookEntry = apiBasePath + '/api/tran_book_entry_a.php';
export const apiTranPB = apiBasePath + '/api/tran_pb_a.php';
export const apiTranSP = apiBasePath + '/api/tran_sp_a.php';
export const apiTranTRF = apiBasePath + '/api/tran_trf_vtc_a.php';
export const apiChequeDeposit = apiBasePath + '/api/cheque_deposit_a.php';
export const apiBankChequeBookOut = apiBasePath + '/api/bank_cheque_book_out_a.php';
export const apiFormat = apiBasePath + '/api/download_format_a.php';
export const apiReceivedChequeBounce = apiBasePath + '/api/received_cheque_bounce_a.php';
export const apiPrint = apiBasePath + '/api/print_a.php';
export const apiFaViewLog = apiBasePath + '/api/fa_view_a.php';
export const apiIssueChequeBounce = apiBasePath + '/api/issue_cheque_bounce_a.php';
export const apiBankReconciliation = apiBasePath + '/api/bank_reconciliation_a.php';
export const apiCheck = apiBasePath + '/api/sample_checkbox_a.php';
export const apiTRFManualBook = apiBasePath + '/api/tran_trf_manual_book_a.php';
export const apiFinancialLedger = apiBasePath + '/api/financial_ledger_a.php';
export const apiReconciliationActivity = apiBasePath + '/api/reconciliation_activity_a.php';
export const apiCalcTaxable = apiBasePath + "/api/calc_invoice_a.php";
export const apiTrialBalance = apiBasePath + '/api/trial_balance_a.php';
export const apiTranTransferOutVTC = apiBasePath + '/api/tran_transfer_out_vtc_a.php';
export const apiTranTransferOutCurrency = apiBasePath + '/api/tran_transfer_out_currency_a.php';
export const apiTranSB = apiBasePath + '/api/tran_sb_a.php';
export const apiAcceptInterBranch = apiBasePath + '/api/out_log_a.php';
export const apiBillWiseDetail = apiBasePath + '/api/rep_fin_recv_bill_wise_detail_a.php';
export const apiLedgerLink = apiBasePath + '/api/ledger_link_a.php';
export const apiChequeInHandReport = apiBasePath + '/api/cheque_in_hand_report_a.php';
export const apiChequeUsedReport = apiBasePath + '/api/cheque_used_report_a.php';
export const apiIBEntry = apiBasePath + '/api/inter_branch_entry_a.php';
export const apiMargin = apiBasePath + '/api/margin_a.php';
export const apiMasterIBR = apiBasePath + '/api/IBR_a.php';
export const apiDataUnlockRequest = apiBasePath + '/api/tran_data_unlock_request_a.php';
export const apiDataUnlock = apiBasePath + '/api/tran_data_unlock_a.php';
export const apiWriteOff = apiBasePath + '/api/currency_write_off_a.php';
export const apiTransactionReport = apiBasePath + '/api/transaction_report_a.php';
export const apiTranPI = apiBasePath + '/api/tran_pi_a.php';
export const apiCurrencyChange = apiBasePath + '/api/currency_change_a.php';
export const apiCancelManualBook = apiBasePath + '/api/tran_manual_book_cancellation_a.php';
export const apiCancelChequeBook = apiBasePath + '/api/bank_cheque_book_caancellation_a.php';
export const apiSettlementVtm = apiBasePath + '/api/settlement_vtm_a.php';
export const apiTtSettlement = apiBasePath + '/api/tt_settlement_a.php';
export const apiPPAdii = apiBasePath + '/api/tran_pp_adii_a.php';
export const apiUnlockEdit = apiBasePath + '/api/unlock_a.php';
export const apiGVTSettlement = apiBasePath + '/api/glb_vtm_settlement_a.php';
export const apiExpenseTransfer = apiBasePath + '/api/expense_transfer_a.php';
export const apiInternalFundTransfer = apiBasePath + '/api/internal_fund_transfer_a.php';
export const apiFundTransfer = apiBasePath + '/api/fund_transfer_a.php';
export const apiStockInHandReport = apiBasePath + '/api/stock_in_hand_report_a.php';
export const apiManualBookReport = apiBasePath + '/api/manual_book_report_a.php';
export const apifundRequest = apiBasePath + "/api/fund_request_a.php";
export const apiMasterDSR = apiBasePath + '/api/master_dsr_a.php';
export const apiBudget = apiBasePath + '/api/budget_a.php';
export const apiBudgetExecutive = apiBasePath + '/api/budget_executive_a.php';
export const apiFlmReport = apiBasePath + "/api/flm_report_a.php";
export const apiFxDocumentUpload = apiBasePath + "/api/fx_document_a.php";
export const apiTranEVTMSurrender = apiBasePath + "/api/tran_evtm_surrender_a.php";
export const apiTranModulePayment = apiBasePath + "/api/tran_module_payment_a.php";
export const apiAgentLinking = apiBasePath + "/api/agent_linking_a.php";
export const apiCommission = apiBasePath + "/api/commission_a.php";
export const apiBillWiseDetailPayable = apiBasePath + '/api/bill_wise_detail_payable_a.php';
export const apiPaymentReport = apiBasePath + "/api/tran_payment_report_a.php";
export const apiConveyanceEntry = apiBasePath + "/api/tran_conveyance_a.php";
export const apiActivityLogReport = apiBasePath + "/api/activitylog_report_a.php";
export const apiCreditLimit = apiBasePath + "/api/creditlimit_a.php";
export const apiEInvoice = apiBasePath + "/api/einvoice_a.php"

export const apiTranModification = apiBasePath + "/api/tran_modification_a.php"
export const apiModiCommission = apiBasePath + "/api/modification_commission_a.php"
export const apiModiDsrDer = apiBasePath + "/api/tran_modification_dsr_der_a.php"
export const apiModiTransaction = apiBasePath + "/api/modification_transaction_a.php"
export const apiTranSI = apiBasePath + "/api/tran_si_a.php"
export const apiModiPayment = apiBasePath + "/api/tran_modification_payment_a.php";
export const apiRepLedger = apiBasePath + "/api/rep_ledger_a.php";
export const apiSourceOfFund = apiBasePath + '/api/source_of_fund_a.php';
export const apiallbank = apiBasePath + '/api/bank_all_a.php';

export const apivisatype = apiBasePath + '/api/visa_type_a.php';


export const apirepvtmsettlement = apiBasePath + "/api/rep_vtm_settlement_a.php";
export const apivtmutilization = apiBasePath + "/api/vtm_utilization_a.php";
export const apichequeutilization = apiBasePath + "/api/cheque_utilization_a.php";
export const apirepoutstandingcmrp = apiBasePath + "/api/rep_outstanding_cmrp_a.php";
export const apiVtmActivation = apiBasePath + "/api/vtm_activation.php";
export const apiCrossKnockoff = apiBasePath + "/api/tran_crossknockoff_a.php";
export const apiKnockoffView = apiBasePath + "api/tran_knockoff_view_a.php";
export const apiVtmProfitability = apiBasePath + "api/vtm_profitability_a.php";
export const apiValuation = apiBasePath + 'api/valuation_a.php';
export const apirbipurchase = apiBasePath + 'api/rbi_purchase_a.php';
export const apirbiturnover = apiBasePath + 'api/rbi_turnover_a.php';
export const apirepgst = apiBasePath + 'api/rep_gst_a.php';
export const apibalancesheet = apiBasePath + 'api/balance_sheet_a.php';
export const apiTranTransferOutIssuerVTC = apiBasePath + '/api/tran_transfer_out_issuer_vtm_a.php';
export const apiVTMStatusReport = apiBasePath + '/api/rep_vtm_status_a.php';
export const apiRepSftp = apiBasePath + '/api/rep_sftp_a.php';
export const apiRepProfitabilityTransaction = apiBasePath + '/api/rep_profitability_transaction_a.php';
export const apiRepProfitabilityContribution = apiBasePath + '/api/rep_profitability_contribution_a.php';
export const apiRepStockValuation = apiBasePath + '/api/rep_stock_valuation_a.php';
export const apiA2Form = apiBasePath + '/api/a2_form_a.php';
export const apiRepvtminout = apiBasePath + '/api/rep_vtm_in_out_a.php'
export const apiRepTellerSheet = apiBasePath + '/api/rep_teller_sheet_a.php'
export const apiChequeReceived = apiBasePath + '/api/cheque_received_a.php'
export const apitranvtminview = apiBasePath + '/api/vtm_in_view_a.php'
export const apitrancurrencyinview = apiBasePath + '/api/currency_in_view_a.php'
export const apitranchequeinview = apiBasePath + '/api/cheque_in_view_a.php'
export const apirepknockoff = apiBasePath + '/api/rep_knockoff_a.php'
export const apideletebill = apiBasePath + '/api/tran_delete_bill_a.php'
export const apiChequeStatusReport = apiBasePath + '/api/rep_cheque_status_a.php';
export const apiRiskConfiguration = apiBasePath + '/api/risk_configuration_a.php';
export const apiSanctionsApproval = apiBasePath + '/api/sanctions_approval_a.php';


export const apiTranChangeDate = apiBasePath + 'api/tran_change_date_a.php';
export const apisanctionsheader = apiBasePath + '/api/sanctions_header_a.php';
export const apiRepTcs = apiBasePath + 'api/rep_tcs_a.php';
export const apiPassport = apiBasePath + 'api/passport_a.php';
export const apiTCS_eligibily_report = apiBasePath + 'api/tcs_eligibility_a.php';
export const apiRepLrs = apiBasePath + 'api/rep_lrs_a.php';
export const apiRepInvestigation = apiBasePath + 'api/rep_insurence_a.php';
export const apiReppositionSummary = apiBasePath + 'api/rep_position_summary_a.php'
export const apiRepLrsRbi = apiBasePath + 'api/rep_lrs_rbi_a.php';

export const apiRepCtr = apiBasePath + '/api/rep_ctr_a.php';
export const apiAdiiInward = apiBasePath + '/api/tran_adii_inward_a.php';
export const apirepcmrpageing = apiBasePath + "/api/rep_outstanding_cmrp_ageing_a.php";
export const apirepmtmHO = apiBasePath + '/api/rep_mtm_ho_a.php';
export const apitransactionmisHO = apiBasePath + '/api/rep_mis_transaction_ho_a.php';
export const apiRemittenceReport = apiBasePath + "/api/rep_remittence_tour_a.php";
export const apiPurchaseSaleReport = apiBasePath + "/api/rep_purchase_sale_a.php";
export const apiTranScanningReport = apiBasePath + '/api/tran_scanning_report_a.php';
export const apiAirline = apiBasePath + '/api/airline_a.php';
export const apiPanWhitelist = apiBasePath + '/api/panwhitelist_a.php';
export const apiPrincipleModule = apiBasePath + '/api/tran_principle_module_a.php';
export const apiCommissionreport = apiBasePath + '/api/rep_commission_a.php';
export const apiDetailsModification = apiBasePath + "/api/details_modification_a.php";
export const apiPpSpModification = apiBasePath + "/api/pp_sp_modification_a.php";
export const apiCrossKnockoffupdated = apiBasePath + "/api/tran_crossknockoff_updated_a.php";
export const apiPrincipleReport = apiBasePath + "/api/principle_report_a.php";
export const apiConvera = apiBasePath + "/api/convera_a.php";
// export const converaPaymentTrackerURL = "https://uat.students.convera.com/#!/tracking";
export const apiUsdConfiguration = apiBasePath + '/api/usdconfiguration_a.php';
export const liveSetup = apiBasePath + "/api/liveSetup_a.php";
export const apiAWS = apiBasePath + "/api/aws_a.php";
export const apiMis = apiBasePath + "/api/rep_mis_a.php"
export const apiRepDashboard = apiBasePath + "/api/rep_dashboard_a.php";
export const apiTransferFundInternal = apiBasePath + '/api/transfer_fund_internal_a.php';
export const apiExpenseTrans = apiBasePath + '/api/exp_tran_a.php';
export const apiTranAdi = apiBasePath + '/api/tran_adi_a.php';
export const apiCommom = apiBasePath + '/api/common_a.php';
export const apiAd2Analysis = apiBasePath + '/api/ad2_analysis_a.php';
export const apiCredit = apiBasePath + '/api/credit_schedule_a.php';
export const apiInwardUtilization = apiBasePath + '/api/opening_inward_utilization_a.php';
export const apiettliability = apiBasePath + '/api/ettliability_a.php';







export const editDateLimit = (sessionStorage.editdatelimit ? sessionStorage.editdatelimit : 0) * 1;
export const commissionModificationEditDateLimit = (sessionStorage.commissionModificationEditDateLimit ? sessionStorage.commissionModificationEditDateLimit : 0) * 1;
export const maximumLength = 10;
export const maxFromLength = 16;
export const prefixLength = 5;
export const rateMaxLength = 10;

// CONVERA variable start
const isConveraLive = sessionStorage.getItem('isLive');
console.log(isConveraLive);
let CONVERAID;
let CONVERASECRET;
let CONVERASRC;
let converaPaymentTrackerURL;//"https://sandbox-uat.spm.convera.com/static/js/main.js"
if (isConveraLive === 'true') {
    CONVERASRC = "https://paymentmodule.convera.com/static/js/main.js";
    converaPaymentTrackerURL = "https://students.convera.com/#!/tracking";
    CONVERAID = "c4cc451d6cad46aab3939093ba8631ae";
    CONVERASECRET = "e3d8a242a7b54dc5884895bcbcbb14a1";
} else {
    CONVERASRC = "https://sandbox-uat.spm.convera.com/static/js/main.js";
    converaPaymentTrackerURL = "https://uat.students.convera.com/#!/tracking";
    CONVERAID = "85a9f788e6d449df8f6d03648b7c2706"; // You may want to change this if there's a different sandbox ID
    CONVERASECRET = "bd41618292dc44d6a949cb7ec0f45188"; // Same here
}
export { CONVERASRC, converaPaymentTrackerURL, CONVERAID, CONVERASECRET };
// CONVERA variable end

//export const validEmail = new RegExp( '^[a-zA-Z0-9._:$!%-]+@[a-zA-Z0-9.-]+.[a-zA-Z]$'  );
export const validPassword = new RegExp('^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,20}$');
//      '^(?=.*?[A-Za-z])(?=.*?[0-9]).{6,}$'
//     '/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,20}$/';

export const removeSpecialChar = (getString) => {
    if (typeof getString != 'number' && getString != null) {
        getString = getString.replace(/\&amp;/g, "and");
        getString = getString.replace(/\&/g, "and");
        getString = getString.replace(/\$/g, " ");
        getString = getString.replace(/\#/g, " ");
        getString = getString.replace(/\*/g, " ");
        getString = getString.replace(/\</g, " ");
        getString = getString.replace(/\>/g, " ");
        getString = getString.replace(/\-/g, " ");
        getString = getString.replace(/\_/g, " ");
        getString = getString.replace(/\+/g, " ");
        getString = getString.replace(/\%/g, " ");
    }
    return getString;
}

function replaceSpecialChar(getString) {
    if (typeof getString != 'number' && getString != null) {
        getString = getString.replace(/\#/g, "^^hash^^");
        getString = getString.replace(/\+/g, "^^plus^^");
        getString = getString.replace(/\%/g, "^^mod^^");
        getString = getString.replace(/\&amp;/g, "^^and^^");
        getString = getString.replace(/\&/g, "^^and^^");
    }
    return getString;
}

function ajaxRequest() {
    if (window.XMLHttpRequest) {// code for IE7+, Firefox, Chrome, Opera, Safari
        return new XMLHttpRequest();
    }
}

export const callApi = (url, prm, Success) => {
    var prms = "";
    if (typeof (prm) != "undefined") {
        for (let i = 0; i < prm.length; i++) {
            if (prms.length > 0) prms = prms + "&";
            prms = prms + (i + 1) + '=' + replaceSpecialChar(prm[i]);
        }
    }
    var xhr = new ajaxRequest();
    xhr.onreadystatechange = function () {
        if (xhr.readyState === 4) {
            var SessXML = xhr.responseText.replace(/[\r\n\s]*</g, "<").replace(/[\r\n\s]*$/g, "");
            if (SessXML.indexOf(".php ") >= 0) {
                alert(SessXML);
                //$('.loader').hide();
            }
            else if (SessXML.trim() === '{"status": "MSG0002"}') {
                sessionStorage.clear();
                const myLoc = window.location.href.split('/');
                window.location.replace(myLoc[0] + '//' + myLoc[2] + '/');
            }
            else {
                Success(SessXML);
            }
        }
    }
    xhr.open("POST", url, true);
    xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
    xhr.send(prms);
}

export const formatNumberDisplay = (num) => {
    return new Intl.NumberFormat("en-IN").format(num);
};

const alpRegExp = new RegExp("^([a-zA-Z. ]+)$");
export const validateAlpValue = (e, f) => {
    if (e === "" || alpRegExp.test(e)) {
        f(e);
    } else {
        return false;
    }
}

// Validate Name on Pan =================== 
const nameOnPanRegExp = new RegExp("^([a-zA-Z.' ]+)$");
export const validateNameonPan = (e, f) => {
    if (e === "" || nameOnPanRegExp.test(e)) {
        f(e);
    } else {
        return false;
    }
}

// Input field Validations
const intRegExp = new RegExp('^([0-9]+)$');
export const validateNumValue = (e, f) => {
    if (e === "" || intRegExp.test(e)) {
        f(e);
    } else {
        return false;
    }
}
const floatRegExp = new RegExp('^-?$|^-?\\d*\\.?\\d*$');
export const validateDecValue = (e, f) => {
    if (e === "" || floatRegExp.test(e)) {
        f(e);
    } else {
        return false;
    }
}



const alpNumRegExpWS = new RegExp('^([0-9a-zA-Z]+)$');
export const validateAlpNumWSValue = (e, f) => {
    if (e === "" || alpNumRegExpWS.test(e)) {
        f(e);
    } else {
        return false;
    }
}

const alpNumRegExp = new RegExp('^([0-9a-zA-Z- ]+)$');
export const validateAlpNumValue = (e, f) => {
    if (e === "" || alpNumRegExp.test(e)) {
        f(e);
    } else {
        return false;
    }
}

const alpNumSpl1RegExp = new RegExp('^([0-9a-zA-Z- ]+)$');
export const validateAlpNumSpl1Value = (e, f) => {
    if (e === "" || alpNumSpl1RegExp.test(e)) {
        f(e);
    } else {
        return false;
    }
}
const alpNumSplRegExp = new RegExp('^([0-9a-zA-Z/_!@$^*()#%&\\-., ]+)$');
export const validateAlpNumSplValue = (e, f) => {
    if (e === "" || alpNumSplRegExp.test(e)) {
        f(e);
    } else {
        return false;
    }
}
const alpNumSplRegExpAllowedSingleQuote = new RegExp("^([0-9a-zA-Z/_!@$^*()#%&\\-.,' ]+)$");

export const validateAlpNumSplValueAllowedSingleQuote = (e, f) => {
    if (e === "" || alpNumSplRegExpAllowedSingleQuote.test(e)) {
        f(e);
    } else {
        return false;
    }
}


//const emailRegExp = new RegExp('^[a-zA-Z0-9_.-]+@[a-zA-Z0-9]+[.]+[A-Za-z]+$');
const emailRegExp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,}$/;
export const validtateEmail = (e, f) => {
    if (e === "" || emailRegExp.test(e)) {
        f(e);
    } else {
        f("");
    }
}
const panRegExp = new RegExp('^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$');
export const validatePan = (e, f) => {
    e = e.toUpperCase();
    var letter4_valid = /([A,B,C,F,G,H,J,L,P,T])/;
    var letter4 = e.substring(3, 4);
    if ((e === "" || panRegExp.test(e)) && (letter4_valid.test(letter4))) {
        f(e);
    } else {
        f("");
    }
}

export const validatePanFlag = (e) => {
    e = e.toUpperCase();
    var letter4_valid = /([A,B,C,F,G,H,J,L,P,T])/;
    var letter4 = e.substring(3, 4);
    if ((e === "" || panRegExp.test(e)) && (letter4_valid.test(letter4))) {
        return true;
    } else {
        return false;
    }
}

// Date Conversion
//---------------Change Date Format 
export const dateYMD1 = (dt) => {       // Convert To YYYY-MM-DD old function 
    if (dt === "" || dt === null) {
        return dt;
    } else {
        return dt.toJSON().slice(0, 10);
    }
}

//const date = new Date("Tue Apr 01 2025");
//const localISODate = new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString();
//console.log(localISODate); // "2025-04-01T00:00:00.000Z"

export const dateYMD = (dt) => {       // Convert To YYYY-MM-DD
    if (dt === "" || dt === null) {
        return dt;
    } else {
        var dtstr = dt.toString();
        console.log(dtstr);
        dtstr = dtstr.replace("00:00:00 GMT+0530", "05:30:00 GMT+0530");
        console.log(dtstr);
        dt = new Date(dtstr);
        // return dt.toJSON().slice(0, 10);
        // return dt().toISOString().split('T')[0];

        return dt.toLocaleDateString('en-CA', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            timeZone: 'Asia/Kolkata' // Adjust as per your timezone
        }).replace(/\//g, '-');
    }
}

export const dateDMY = (dt) => {       // Convert to DD/MM/YYYY
    if (dt === "" || dt === null) {
        return dt;
    } else {
        dt = dt.toLocaleDateString('en-CA', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            timeZone: 'Asia/Kolkata' // Adjust as per your timezone
        }).replace(/\//g, '-');
        //return dt.toJSON().slice(0, 10).split('-').reverse().join('/');
        return dt.slice(0, 10).split('-').reverse().join('/');
    }
}

export const dateDMYStr = (dt) => {       // Convert to DD/MM/YYYY
    if (dt === "" || dt === null || dt === undefined) {
        return dt;
    } else {
        return dt.slice(0, 10).split('-').reverse().join('/');
    }
}

export const dateIsEqual = (date1, date2) => {
    let isEqual = false;
    if (date1 != null && date2 != null) {
        if (date1.getDate() === date2.getDate() &&
            date1.getMonth() === date2.getMonth() &&
            date1.getFullYear() === date2.getFullYear()) {
            isEqual = true;
        }
    }
    return isEqual;
}


// Associative array manupulations 

export const arrayRemoveItem = (arr, key, value) => {
    if (arr.length > 0) {
        for (var i = 0; i < arr.length; ++i) {
            if (arr[i][key] === value) {
                arr.splice(i, 1);
            }
        }
    }
    return arr;
}

export const arrayAddItem = (arr, obj) => {
    arr.push(obj);
    // console.log(JSON.stringify(arr,null,' ') );
    return arr;
}

export const arrayAddlog = (arr, obj) => {
    arr.push(obj);
    return arr;
}

export const arrayChangeItem = (arr, uKey, uValue, key, value) => {
    if (arr.length > 0) {
        for (var i = 0; i < arr.length; ++i) {
            if (arr[i][uKey] === uValue) {
                arr[i][key] = value;
            }
        }
    }
    // console.log(JSON.stringify(arr,null,' ') );
    return arr;
}

// RandomString Generator
export const getRandomString = (x = 20) => {
    var a = (Math.random() + 1).toString(36).substring(2);
    var b = (Math.random() + 1).toString(36).substring(2);
    return (a + b).substring(0, x);
}

//formData.append('username', 'Chris');
//formData.append('userpic', myFileInput.files[0], 'chris.jpg');
//
export const uploadApi = (obj, fileId, Success) => {
    var myFile = document.getElementById(fileId);
    var files = myFile.files;
    var file = files[0];

    var formData = new FormData();
    formData.append('1', obj);
    formData.append('file', file, file.name);
    var xhr = new XMLHttpRequest();
    xhr.open("POST", apiUploadFile, true);
    xhr.onload = function () {
        if (xhr.status === 200) {
            var responseText = xhr.responseText.replace(/[\r\n\s]*</g, "<").replace(/[\r\n\s]*$/g, "");

            if (responseText.indexOf(".php") >= 0) {
                alert(responseText);
            } else if (responseText.trim() === '{"status": "MSG0002"}') {
                sessionStorage.clear();
                const myLoc = window.location.href.split('/');
                window.location.replace(myLoc[0] + '//' + myLoc[2] + '/');
            } else {
                Success(responseText);
            }
            // Success('Upload complete!' + responseText);
        } else {
            Success('Upload error. Try again.');
        }
    }
    xhr.send(formData);
}
export const callDownloadApiPost = (path, method, prm) => {
    var form = document.createElement("form");
    form.setAttribute("method", method);
    form.setAttribute("action", path);
    form._submit_function_ = form.submit;

    for (var i = 1; i <= prm.length; i++) {
        var hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", i);
        hiddenField.setAttribute("value", prm[i - 1]);
        form.appendChild(hiddenField);
    }

    document.body.appendChild(form);
    form._submit_function_();
}
//jitendra arya
export const callDownloadApiPost1 = (path, method, prm, Success) => {
    //set data in the form;
    var formData = new FormData();
    for (var i = 0; i < prm.length; i++) {
        formData.append(`${i + 1}`, prm[i]);
    }
    var xhr = new XMLHttpRequest();
    xhr.open(method, path, true);
    xhr.responseType = 'blob'; // Set response type as blob to handle binary data
    xhr.onload = function () {
        if (xhr.status === 200) {
            // Create a blob from the response
            const blob = xhr.response;
            console.log(blob)

            // Get the filename from the Content-Disposition header
            const contentDisposition = xhr.getResponseHeader('Content-Disposition');
            console.log(contentDisposition)
            let filename = "downloaded_file.xlsx"; // Default filename

            if (contentDisposition && contentDisposition.indexOf('attachment') !== -1) {
                const filenameMatch = contentDisposition.split("filename=");
                console.log(filenameMatch)
                if (filenameMatch.length === 2) {
                    filename = filenameMatch[1];
                }
            }

            // Create a link element to download the file
            const url = window.URL.createObjectURL(blob);
            console.log(url)
            const link = document.createElement('a');
            console.log(link)
            link.href = url;
            link.setAttribute('download', filename);

            // Append the link to the document and trigger click to start download
            document.body.appendChild(link);
            link.click();

            // Clean up
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

            // Optionally, call success callback
            const msg = xhr.getResponseHeader('statusText');
            console.log(msg)
            Success && Success(msg || "File downloaded successfully");
        } else {
            console.error("Error during file download: ", xhr.statusText);
            const msg = xhr.getResponseHeader('statusText');
            Success && Success(msg || "Error during file download");
        }
    };

    xhr.onerror = function () {
        console.error("Error during XMLHttpRequest");
    };
    xhr.send(formData);
}

export const callDocumentViewApi = (url, prm, Success) => {
    var prms = "";
    if (typeof (prm) != "undefined") {
        for (let i = 0; i < prm.length; i++) {
            if (prms.length > 0) prms = prms + "&";
            prms = prms + (i + 1) + '=' + replaceSpecialChar(prm[i]);
        }
    }
    var xhr = new ajaxRequest();
    xhr.onreadystatechange = function () {
        if (xhr.readyState === 4) {
            Success(xhr.responseText);
        }
    }
    xhr.open("POST", url, true);
    xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
    xhr.send(prms);
}
export const buildDateFormat = (v, e) => {
    var len = v.length;
    if (len === 2 || len === 5) {
        e.value = v + '/';
    }
}

export const buildMessageFromArray = (prm) => {
    var msg = "", i = 0;
    if (typeof (prm) != "undefined") {
        for (; i < prm.length; i++) {
            if (prm[i] !== "") {
                msg = msg + "<div class='row'><div class='col-sm-12'>" + prm[i] + "</div></div>";
            }
        }
    }
    return msg;
}

export const setPageTitle = (v) => {
    if (v === 0) {
        document.title = "ZeneRemit";
        document.getElementById("ZenFavicon").href = "/favicon.ico";
    } else {
        document.title = "ZeneRemit ( " + v + " )";
        document.getElementById("ZenFavicon").href = "/faviconred.ico";
    }

    // document.getElementById("ZenFavicon").href = "%PUBLIC_URL%/favicon1.ico";
}

export const getPanRelationCode = (v) => {
    var r = "0";
    switch (v.toUpperCase()) {
        case "SELF":
            r = "1";
            break;
        case "HUSBAND":
            r = "2";
            break;
        case "WIFE":
            r = "3";
            break;
        case "SON":
            r = "4";
            break;
        case "DAUGHTER":
            r = "5";
            break;
        case "BROTHER":
            r = "6";
            break;
        case "SISTER":
            r = "7";
            break;
        case "FRIEND":
            r = "8";
            break;
        case "FATHER":
            r = "9";
            break;
        case "MOTHER":
            r = "10";
            break;
        case "OTHER":
            r = "11";
            break;
        default:
            r = "0";
    }
    return r;
}

export const getSrNoFromRefNo = (v) => {
    var refArray = v.split('/');
    var refArrayLength = refArray.length;
    var lastItem = refArray[refArrayLength - 1];
    var srno = lastItem.substring(1);
    return srno;
}

export function calcGSTTaxableValue(fxamnt, totchrg) {
    var GSTTaxableValslab = [250, 60000, 100000, 1000000, 0.01, 0.005, 0.001, 1000, 5500];
    //var fxamnt = $('#txtPayFxAmnt').val() * 1;
    //var totchrg = $("#txtPayTotChrg").val() * 1;
    var policy = 2; // sessionStorage.gstpolicy * 1;
    var TaxableVal = 0;
    switch (policy) {
        case 1: // total fx and charges then calculate taxable
            if (fxamnt + totchrg > 0 && fxamnt + totchrg <= GSTTaxableValslab[2]) {
                TaxableVal = Math.round((fxamnt + totchrg) * GSTTaxableValslab[4] * 100) / 100;
            } else if (fxamnt + totchrg > GSTTaxableValslab[2] && fxamnt + totchrg <= GSTTaxableValslab[3]) {
                TaxableVal = GSTTaxableValslab[7] + Math.round((fxamnt + totchrg - GSTTaxableValslab[2]) * GSTTaxableValslab[5] * 100) / 100;
            } else if (fxamnt + totchrg > GSTTaxableValslab[3]) {
                TaxableVal = GSTTaxableValslab[8] + Math.round((fxamnt + totchrg - GSTTaxableValslab[3]) * GSTTaxableValslab[6] * 100) / 100;
            }
            break;
        case 2: // calculate taxable from fx then add charges
            if (fxamnt > 0 && fxamnt <= GSTTaxableValslab[2]) {
                TaxableVal = Math.round((fxamnt) * GSTTaxableValslab[4] * 100) / 100;
            } else if (fxamnt > GSTTaxableValslab[2] && fxamnt <= GSTTaxableValslab[3]) {
                TaxableVal = GSTTaxableValslab[7] + Math.round((fxamnt - GSTTaxableValslab[2]) * GSTTaxableValslab[5] * 100) / 100;
            } else if (fxamnt > GSTTaxableValslab[3]) {
                TaxableVal = GSTTaxableValslab[8] + Math.round((fxamnt - GSTTaxableValslab[3]) * GSTTaxableValslab[6] * 100) / 100;
            }

            break;
        case 3: // calculate taxable only from fx
            if (fxamnt > 0 && fxamnt <= GSTTaxableValslab[2]) {
                TaxableVal = Math.round((fxamnt) * GSTTaxableValslab[4] * 100) / 100;
            } else if (fxamnt > GSTTaxableValslab[2] && fxamnt <= GSTTaxableValslab[3]) {
                TaxableVal = GSTTaxableValslab[7] + Math.round((fxamnt - GSTTaxableValslab[2]) * GSTTaxableValslab[5] * 100) / 100;
            } else if (fxamnt > GSTTaxableValslab[3]) {
                TaxableVal = GSTTaxableValslab[8] + Math.round((fxamnt - GSTTaxableValslab[3]) * GSTTaxableValslab[6] * 100) / 100;
            }
            break;
    }
    if (TaxableVal < GSTTaxableValslab[0])
        TaxableVal = GSTTaxableValslab[0];
    if (TaxableVal > GSTTaxableValslab[1])
        TaxableVal = GSTTaxableValslab[1];
    if (policy == 2) {
        TaxableVal += totchrg;
    }
    return (Math.round(TaxableVal * 100) / 100);
}

const passportRegExp = new RegExp('^[A-Z][0-9]\\d\\s?\\d{4}[0-9]$');
export const validatePassport = (e, f) => {
    if (e === "" || passportRegExp.test(e)) {
        f(e);
    } else {
        //f("");
        f(e);
    }
}

const adhaarRegExp = new RegExp('^[2-9]{1}[0-9]{3}[0-9]{4}[0-9]{4}$');
export const validateAdhaar = (e, f) => {
    e = e.toUpperCase();
    //var letter4 = e.substring(3, 4);
    if (e === "" || adhaarRegExp.test(e)) {
        f(e);
    } else {
        //f("");
        f(e);
    }
}


export function getActiveBranch() {
    return new Promise((resolve, reject) => {
        const sid = sessionStorage.getItem("sessionId");
        const activeBranch = sessionStorage.getItem("activeBranch");
        callApi(apiEntity, [sid, "activelocation", activeBranch], result => {
            const response = JSON.parse(result);
            resolve(response);
        });
    });
}


// Validate GST--------------------------------------------
// const gstRegExp = new RegExp('^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$');
const gstRegExp = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z][0-9A-Z]{3}$/;
export const validateGST = (e, f) => {
    e = e.toUpperCase();
    if (e === "" || gstRegExp.test(e)) {
        f(e);
    } else {
        f("");
    }
}

// Regular expression for validating IFSC Code
const ifscRegex = new RegExp('^[A-Z]{4}0[A-Z0-9]{6}$');
export function validateIFSC(e, f) {
    e = e.toUpperCase();
    f(e); // always update state

    // Optional: warning for full IFSC validation
    if (e !== "" && !ifscRegex.test(e)) {
        console.warn("Invalid IFSC:", e);
    }
}


// Validate Mobile Number-------------------------
const mobileNumberRegExp = new RegExp('^[6-9]{1}[0-9]{9}$');
export const validateMobileNumber = (e, f) => {
    if (e === "" || mobileNumberRegExp.test(e)) {
        f(e);
    } else {
        f("");
    }
}

// IRN cancel reasons
export const getIrnCancelReason = [
    { id: "1", desc: "DUPLICATE" },
    { id: "2", desc: "DATA ENTRY MISTAKE" },
    { id: "3", desc: "ORDER CANCELLED" },
    { id: "4", desc: "OTHERS" }
];


// all right common api call
export function callApiPromise(api, params) {
    return new Promise((resolve, reject) => {
        callApi(api, params, function (result) {
            try {
                const resp = JSON.parse(result);
                resolve(resp);
            } catch (error) {
                reject(error);
            }
        });
    });
}

export function isPurelyNumeric(value) {
    // return /^[0-9]+(\.[0-9]+)?$/.test(value.trim()); // for this -0.1 is false,.5 is also false.
    // return /^\d+$/.test(value.trim()); // Returns true if the input is all numeric
    let val;
    if(typeof value !== 'string') {
        val = String(value);
    }else{
        val = value.trim();
    }
    return /^-?(?:[0-9]+(?:\.[0-9]+)?|\.[0-9]+)$/.test(val);
}

// ---------------------FUNCTION TO COMPARE TWO ARRAY AND RETURN UNMATCHED ITEMS AS AN OBJECT --------------
export function compareArrays(arr1, arr2) {
    const mismatchesValue1 = {};
    const mismatchesValue2 = {};
    arr1.forEach((obj1) => {
        for (const key in obj1) {
            const value1 = obj1[key];
            const obj2 = arr2.find((item) => key in item);
            if (obj2) {
                const value2 = obj2[key];
                if (typeof value1 === "object" && value1 !== null) {
                    if (typeof value2 === "object" && value2 !== null) {
                        if (Array.isArray(value1) || Array.isArray(value2)) {
                            if (JSON.stringify(value1) !== JSON.stringify(value2)) {
                                mismatchesValue1[key] = value1;
                                mismatchesValue2[key] = value2;
                            }
                        }
                        // if (value1.id && value2.id && value1.id !== value2.id) {
                        //     mismatchesValue1[key] = value1;
                        //     mismatchesValue2[key] = value2;
                        // } else 
                    console.log("value2", value1);
                        if (value1.label && value2.label && value1.label != value2.label) {
                            mismatchesValue1[key] = value1;
                            mismatchesValue2[key] = value2;
                        }
                        // else {
                        //     for (const nestedKey in value1) {
                        //         if (value1[nestedKey] !== value2[nestedKey]) {
                        //             mismatchesValue1[key] = value1;
                        //             mismatchesValue2[key] = value2;
                        //             break;
                        //         }
                        //     }
                        // }
                    } else {
                        mismatchesValue1[key] = value1;
                        mismatchesValue2[key] = null;
                    }
                } else if (value1 != value2) {
                    mismatchesValue1[key] = value1;
                    mismatchesValue2[key] = value2;
                }
            } else {
                mismatchesValue1[key] = value1;
                mismatchesValue2[key] = null;
            }
        }
    });
    return {
        deleted: mismatchesValue1,
        added: mismatchesValue2
    };
}

export function compareArraysWithKeys(beforeArray, afterArray, keys) {
    const getKey = (obj) => keys.map(key => String(obj[key]).trim()).join('|');
    const afterMap = new Map(afterArray.map(obj => [getKey(obj), obj]));
    const added = [];
    const deleted = [];
    beforeArray.forEach(beforeObj => {
        const keyValuesConcat = getKey(beforeObj);
        const afterObj = afterMap.get(keyValuesConcat);
        if (!afterObj) {
            deleted.push(beforeObj);
        } else {
            const changed = Object.keys(beforeObj).some(field => String(beforeObj[field]).trim() !== String(afterObj[field]).trim());
            if (changed) {
                deleted.push(beforeObj);
                added.push(afterObj);
            }
            afterMap.delete(keyValuesConcat);
        }
    });
    added.push(...afterMap.values());
    return { deleted, added };
}

//---------------------FUNCTION TO ADD ADD/DELETE INFO IN UNMATCHED AUDITTRAIL INFO ------------------------

export function addInfoToAuditTrail(tranAuditTrail, infoObject, ttype, location = null) {
    const auditObjectAdd = {
        TabType: "Info",
        ...(location !== null && { TLoc: location }),
        ALineNo: tranAuditTrail.length + 1,
        TType: ttype,
        AType: "A",
    };

    const auditObjectDelete = {
        TabType: "Info",
        ...(location !== null && { TLoc: location }),
        ALineNo: tranAuditTrail.length + 1,
        TType: ttype,
        AType: "D",
    };

    const combinedObjectValue1 = {
        ...infoObject.added,
        ...auditObjectAdd,
    };
    const combinedObjectValue2 = {
        ...infoObject.deleted,
        ...auditObjectDelete,
    };

    arrayAddItem(tranAuditTrail, combinedObjectValue1);
    arrayAddItem(tranAuditTrail, combinedObjectValue2);

    return tranAuditTrail;
}

//------------------------------------------------------------------------------SAME PAYMENT METHOD VALIDATION 
export function isSamePaymentMethod(obj, paymentdata) {
    return paymentdata.find((item) => {
        const isBasicMatch =
            item.tp_payment_type === obj.tp_payment_type &&
            item.tp_account === obj.tp_account &&
            item.tp_group === obj.tp_group;
        const isBankSelected =
            obj.tp_payment_type === 'BANK'
                ? item.tp_cheque === obj.tp_cheque
                : true;
        const isChequeSelected =
            obj.tp_payment_type === 'CHEQUE'
                ? item.chequeValue === obj.chequeValue
                : true;
        return isBasicMatch && isBankSelected && isChequeSelected;
    });
}

export function dateDifference(date1, date2) {
    console.log(date1)
    console.log(date2)

    if (date1 && date2) {
        const a = new Date(date1.toJSON().slice(0, 10));
        const b = new Date(date2.toJSON().slice(0, 10));
        const diffTime = Math.abs(a - b);
        console.log(a, b, diffTime)
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
        console.log(diffDays);
        return diffDays === 0 ? 1 : diffDays;
    } else {
        console.log(date1);
        console.log(date2);
    }
}


export function getActiveBranchWithoutHo() {
    return new Promise((resolve, reject) => {
        const sid = sessionStorage.getItem("sessionId");
        const activeBranch = sessionStorage.getItem("activeBranchWithoutHo");
        callApi(apiEntity, [sid, "activelocation", activeBranch], result => {
            const response = JSON.parse(result);
            resolve(response);
        });
    });
}

export function getDateChangeRight(sid, setFunction) {
    callApi(apiRight, [sid, 'all', 'TRAN_DATE_CHANGE'], function (result) {
        let resp = JSON.parse(result);
        if (resp.query === "1") {
            setFunction(resp);
        }
    });
}
export function checkAvailableStock(obj, arr) {
    return new Promise((resolve, reject) => {
        let totalquantity = 0;
        const sid = sessionStorage.getItem("sessionId");
        for (let i = 0; i < arr.length; i++) {
            if (arr[i].prd_isd == obj.prd_isd && arr[i].prd_deno == obj.prd_deno) {
                totalquantity = totalquantity + arr[i].prd_qty * 1;
            }
        }
        const obj1 = {
            isd: obj.prd_isd,
            date: obj.prd_date,
            deno: obj.prd_deno,
            //location: (obj.prd_type == 'CNOUT' || obj.prd_type == 'CNWOFF' || obj.prd_type == "CNCHNG") ? obj.prd_location : ""
            location: obj.prd_location,
            srno: obj.prd_srno,
            type: obj.prd_type
        }
        callApi(apiMasterIBR, [sid, "checkStock", JSON.stringify(obj1)], result => {
            try {
                let resp = JSON.parse(result);
                resolve((1 * totalquantity + obj.prd_qty * 1) <= resp.quantity * 1);
            } catch (error) {
                reject(error);
            }
        });
    });
}


export function addWithInitialZeroes(from, qty, f) {
    let newNum = (parseInt(from, 10) + qty).toString();
    f(newNum.padStart(from.length, '0'));
}
export function getYmdHis() {
    const now = new Date();
    const pad = n => String(n).padStart(2, '0');
    return (
        now.getFullYear().toString() +
        pad(now.getMonth() + 1) +
        pad(now.getDate()) +
        pad(now.getHours()) +
        pad(now.getMinutes()) +
        pad(now.getSeconds())
    );
}
export async function uploadFiletoAWSbucket(url, file) {
    try {
        console.log("Uploading to AWS URL:", url);
        console.log("File details:", file.name, file.type, file.size);

        const resp = await fetch(url, {
            method: "PUT",
            body: file,
        });

        const respText = await resp.text();

        console.log("AWS Response:", resp.status, respText);

        if (resp.ok) {
            return { ok: true, status: resp.status };
        } else {
            return { ok: false, status: resp.status, body: respText };
        }
    } catch (err) {
        console.error("AWS upload error:", err);
        return { ok: false, error: String(err) };
    }
}

export async function getIndividualProfilebyProfileIdAndIdCode(type, [individualsrno, idSrno], setFun) {
    if (individualsrno > 0) {
        const obj = {
            individualsrno: individualsrno,
            idSrno: idSrno,
            type: type
        }
        const sid = sessionStorage.getItem("sessionId");
        callApi(apiIndividualProfile, [sid, "individualidfrompicklist", JSON.stringify(obj)], result => {
            let resp = JSON.parse(result);
            setFun(resp);
        });
    }
}
export async function getCorporateProfilebyGroupAndAccount(type, [group, account], setFun) {
    if (group > 0 && account) {
        const obj = {
            group: group,
            account: account,
            type: type
        }
        const sid = sessionStorage.getItem("sessionId");
        callApi(apiLedger, [sid, "legerByGroupAccForPicklist", JSON.stringify(obj)], result => {
            let resp = JSON.parse(result);
            if (resp.status) {
                setFun(resp.list);
            }
        });
    }
}

export const isWithinOneMonth = (from, to) => {
    if (!from || !to) return false;

    const startDate = new Date(from);
    const endDate = new Date(to);

    // 1. Ensure the start date is actually before or equal to the end date
    if (startDate > endDate) return false;

    // 2. Create a new date that is exactly 1 month after the start date
    const maxAllowedDate = new Date(startDate);
    maxAllowedDate.setMonth(maxAllowedDate.getMonth() + 1);

    // 3. Check if the endDate is within that 1-month window
    return endDate <= maxAllowedDate;
};

const finStartDate = sessionStorage.getItem("startDate");
const finEndDate = sessionStorage.getItem("endDate");

// validate the args date is between fin year
export function validateFinYear(...args) {
    let status = true;
    console.log(args);
    args.forEach((d) => {
        if (d > finEndDate || d < finStartDate) {
            status = false;
        }
    });
    return status;
}


export const fetchCommission = true;

